import { render } from "./ArticleSearch.vue?vue&type=template&id=64f9b746"
import script from "./ArticleSearch.vue?vue&type=script&lang=js"
export * from "./ArticleSearch.vue?vue&type=script&lang=js"

import "./ArticleSearch.vue?vue&type=style&index=0&id=64f9b746&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__